/*
 * VitaFresh: PostHog im Shop (Plan docs/plans/2026-11-03-posthog-shop.md im Umbrella, Marlon 03.11.2026).
 * Dasselbe Projekt und Cookie wie welcome.vitafresh.ch, damit Landing und Shop eine Person bleiben.
 * Anonym: kein identify, keine Kundendaten. Startet erst nach dem Laden und der ersten Regung, nur mit Analyse-Erlaubnis.
 * Kein PostHog auf Kontoseiten, /pages/einladung und /pages/liefertag (Bedingung in layout/theme.liquid).
 * Oben reine Logik, unten die Anbindung ans DOM. ES2017, kein Build.
 */
(function (root) {
  "use strict";

  var SCHLUESSEL = "phc_q9J9qDhHfnJqDiw9hBufNMXpz6ZJaVjXUCKKKbesYPFF"; // öffentlicher Projekt-Schlüssel
  var HOST = "https://eu.i.posthog.com"; // EU-Region (Frankfurt)
  var LANDING = "https://welcome.vitafresh.ch/";
  var AUFNAHME_ANTEIL = 0.5; // Gratisgrenze 5000 Aufnahmen/Monat; Besucher von der Landing immer ganz
  var ERLAUBTE_PARAMETER = /^(utm_.+|q|page|sort_by|filter\..+)$/;
  var VERDECKTE_PARAMETER = ["vf_plz", "von", "bestellung", "_kx", "customer_posted", "return_url"];
  var ADRESS_FELDER = ["$current_url", "$initial_current_url", "$session_entry_url", "$referrer", "$initial_referrer", "$session_entry_referrer"];
  // In Aufnahmen ausgeblendet: Liefertermin, Versandrechner und Empfehlungsrabatt tragen PLZ, Adresse oder Code im Seitencode,
  // die Pixel-Rahmen von Shopify die ursprüngliche Adresse samt vf_plz.
  var GESCHUETZT = '[data-vflt], .shipping-calculator, .vfwk-empf-hinweis, iframe[name^="web-pixel-sandbox"]';
  var GESCHUETZTER_TEXT = "[data-vfk-plz-wert]"; // PLZ in der Kopfzeile
  var RESTE = /([?&](?:vf_plz|von|bestellung|_kx|customer_posted|return_url)=)[^&"'\\\s]*/g;

  /* Nur die vf_plz fällt aus der Adresse: Sie ist da schon gemerkt (layout/theme.liquid), alles andere lesen Seiten auch beim Neuladen. */
  function ohnePlz(adresse) {
    var u = new URL(adresse);
    if (!u.searchParams.has("vf_plz")) return adresse;
    u.searchParams.delete("vf_plz");
    return u.href;
  }

  function nurErlaubteParameter(adresse) {
    if (typeof adresse !== "string" || adresse.indexOf("?") < 0) return adresse;
    var u;
    try { u = new URL(adresse); } catch (e) { return adresse; }
    Array.from(u.searchParams.keys()).forEach(function (k) {
      if (!ERLAUBTE_PARAMETER.test(k)) u.searchParams.delete(k);
    });
    return u.href;
  }

  function ohneParameter(adresse) {
    return typeof adresse === "string" ? adresse.split("?")[0] : adresse;
  }

  /* Letzte Sicherung vor dem Senden. Klicks im geschützten Bereich trügen die PLZ über die Attribute der Eltern-Elemente mit. */
  function vorDemSenden(ereignis) {
    if (!ereignis || !ereignis.properties) return ereignis;
    var p = ereignis.properties;
    var kette = JSON.stringify(p.$elements || "") + (p.$elements_chain || "");
    if (/data-vflt|data-kunde-plz|shipping-calculator|vfwk-empf|vfk-plz/.test(kette)) return null;
    ADRESS_FELDER.forEach(function (f) { if (p[f]) p[f] = nurErlaubteParameter(p[f]); });
    ereignis.properties = JSON.parse(JSON.stringify(p).replace(RESTE, "$1<MASKED>"));
    return ereignis;
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { ohnePlz: ohnePlz, nurErlaubteParameter: nurErlaubteParameter, ohneParameter: ohneParameter, vorDemSenden: vorDemSenden };
    return;
  }

  /* ============ Anbindung ============ */

  /* Einmal von der Landing heisst: die ganze Sitzung in diesem Tab ganz aufnehmen, damit der Trichter vollständig bleibt. */
  function vonDerLanding() {
    try {
      if ((document.referrer || "").indexOf(LANDING) === 0 || sessionStorage.getItem("vf_plz")) sessionStorage.setItem("vf_ph_landing", "1");
      return sessionStorage.getItem("vf_ph_landing") === "1";
    } catch (e) {
      return false;
    }
  }

  function erlaubt() {
    var cp = root.Shopify && root.Shopify.customerPrivacy;
    return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
  }

  var gestartet = false;
  function starten() {
    if (gestartet) return;
    gestartet = true;
    try { history.replaceState(history.state, "", ohnePlz(location.href)); } catch (e) {}
    // Offizieller Loader, wie landing/assets/js/tracking.js
    !function (t, e) {
    var o, n, p, r; e.__SV || (window.posthog = e, e._i = [], e.init = function (i, s, a) {
    function g(t, e) { var o = e.split("."); 2 == o.length && (t = t[o[0]], e = o[1]); t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }
    (p = t.createElement("script")).type = "text/javascript"; p.crossOrigin = "anonymous"; p.async = !0;
    p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js";
    (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
    var u = e; for (void 0 !== a ? u = e[a] = [] : a = "posthog", u.people = u.people || [],
    u.toString = function (t) { var e = "posthog"; return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e; },
    u.people.toString = function () { return u.toString(1) + ".people (stub)"; },
    o = "init capture register register_once unregister identify reset get_distinct_id get_session_id set_config startSessionRecording stopSessionRecording opt_in_capturing opt_out_capturing has_opted_out_capturing getFeatureFlag isFeatureEnabled onFeatureFlags".split(" "), n = 0; n < o.length; n++) g(u, o[n]);
    e._i.push([i, s, a]);
    }, e.__SV = 1);
    }(document, window.posthog || []);
    root.posthog.init(SCHLUESSEL, {
      api_host: HOST,
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      disable_surveys: true,
      mask_personal_data_properties: true,
      custom_personal_data_properties: VERDECKTE_PARAMETER,
      autocapture: { css_selector_ignorelist: [GESCHUETZT, ".vfk-plz"] },
      before_send: vorDemSenden,
      session_recording: {
        sampleRate: vonDerLanding() ? 1 : AUFNAHME_ANTEIL,
        maskAllInputs: true,
        blockSelector: GESCHUETZT,
        maskTextSelector: GESCHUETZTER_TEXT,
        maskCapturedNetworkRequestFn: function (anfrage) {
          anfrage.name = ohneParameter(anfrage.name);
          return anfrage;
        }
      }
    });
  }

  document.addEventListener("visitorConsentCollected", function (e) {
    var ja = !!(e.detail && e.detail.analyticsAllowed);
    if (ja && !gestartet) return starten();
    if (!root.posthog || !gestartet) return;
    if (ja) {
      root.posthog.opt_in_capturing();
    } else {
      root.posthog.opt_out_capturing();
      root.posthog.stopSessionRecording();
    }
  });

  function pruefen() {
    if (erlaubt()) starten();
  }

  function nachDemLaden() {
    var cp = root.Shopify && root.Shopify.customerPrivacy;
    if (cp) return pruefen();
    if (!root.Shopify || !root.Shopify.loadFeatures) return; // ohne Erlaubnis-Prüfung kein Start
    root.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (fehler) {
      if (!fehler) pruefen();
    });
  }

  function imLeerlauf() {
    if (root.requestIdleCallback) root.requestIdleCallback(nachDemLaden, { timeout: 2000 });
    else setTimeout(nachDemLaden, 200);
  }

  /* Start erst nach dem Laden und der ersten Regung (Tempo geht vor, Messung 03.11.2026: sonst mehr als dreifache Blockierzeit
     im Labor auf Kollektionen). Besuche ohne jede Regung zählen dafür nicht; Google-Crawler und PageSpeed bleiben unberührt. */
  var REGUNGEN = ["pointerdown", "keydown", "touchstart", "scroll"];
  var geregt = false;
  function regung() {
    if (geregt) return;
    geregt = true;
    REGUNGEN.forEach(function (n) { root.removeEventListener(n, regung, true); });
    if (document.readyState === "complete") imLeerlauf();
    else root.addEventListener("load", imLeerlauf);
  }
  REGUNGEN.forEach(function (n) { root.addEventListener(n, regung, { capture: true, passive: true }); });
})(typeof window !== "undefined" ? window : globalThis);
